import { render, staticRenderFns } from "./m_readaloud.vue?vue&type=template&id=2cc77499&scoped=true&"
import script from "./m_readaloud.vue?vue&type=script&lang=js&"
export * from "./m_readaloud.vue?vue&type=script&lang=js&"
import style0 from "./m_readaloud.vue?vue&type=style&index=0&id=2cc77499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc77499",
  null
  
)

export default component.exports